export const nameByGuid = {
  'TRM-ACR-001': 'TRM-ACR-001',
  'TRM-ACR-002': 'TRM-ACR-002',
  'TRM-ACR-003': 'TRM-ACR-003',
  '1b2a6e32-f9d4-4b4d-8e2b-35f727cb24f1': 'TRM-ACR-004',
};

export const getTerminalName = (terminal) => {
  if (!terminal) return 'Terminal';
  return nameByGuid[terminal.guid] || terminal.descripcion || terminal.guid || 'Terminal';
};
